export interface SortConfig {
  sortBy: string;
  sortOrder: "asc" | "desc";
}

// columns.tsx
import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

interface SortableColumnProps {
  label: string;
  columnKey: any;
  sortConfig: SortConfig;
  onSort: (columnKey: any) => void;
}

export const SortableColumn: React.FC<{
  label: string;
  columnKey: string;
  sortBy: string;
  sortOrder: string;
  onSort: (column: string) => void;
}> = ({ label, columnKey, sortBy, sortOrder, onSort }) => {
  const isActive = sortBy === columnKey;
  const isAsc = sortOrder === "asc";

  return (
    <Button
      variant="ghost"
      onClick={() => onSort(columnKey)}
      className={cn(
        "h-auto min-h-8 justify-start gap-2 !px-0 !py-1 text-[11.5px] font-bold uppercase tracking-[0.06em] text-muted-foreground hover:bg-muted/60",
        isActive && "text-foreground dark:text-white"
      )}
    >
      <span>{label}</span>
      <span className="inline-flex shrink-0 items-center">
        {isActive ? (
          isAsc ? (
            <ArrowUp
              className="h-4 w-4 font-bold text-foreground dark:text-white"
              strokeWidth={3}
            />
          ) : (
            <ArrowDown
              strokeWidth={3}
              className="h-4 w-4 font-bold text-foreground dark:text-white"
            />
          )
        ) : (
          <ArrowUpDown className="h-4 w-4 text-muted-foreground" />
        )}
      </span>
    </Button>
  );
};
